import { Component } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { UserOptionType } from '../types/OptionTypes';
import { getSortedUsers, formatUserFullNameForDisplay } from '../utils/UserUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UserCheckbox = ({
  id,
  email,
  displayName,
  checked,
  isMemberOfSelectedTeam,
  onAddUser,
  onRemoveUser,
  disabled,
  disallowedUserTooltip
}) => {
  const checkbox = /*#__PURE__*/_jsx(UICheckbox, {
    value: id,
    checked: checked,
    disabled: isMemberOfSelectedTeam || disabled,
    alignment: "center",
    className: "p-y-1",
    "data-test-id": "user-checkbox",
    onChange: () => {
      if (checked) {
        onRemoveUser(id);
      } else {
        onAddUser(id);
      }
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: "align-center",
      "data-test-id": `assign-user-checkbox-${id}`,
      children: [/*#__PURE__*/_jsx("span", {
        className: "m-right-2",
        children: /*#__PURE__*/_jsx(UIAvatar, {
          size: "xs",
          displayName: email,
          lookup: {
            type: 'hubSpotUserEmail',
            primaryIdentifier: email
          }
        })
      }), displayName]
    })
  });
  if (isMemberOfSelectedTeam) {
    return /*#__PURE__*/_jsx(UITooltip, {
      placement: "left",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-asset-management-lib.tooltips.userTooltip"
      }),
      children: checkbox
    });
  }
  if (disabled && disallowedUserTooltip) {
    return /*#__PURE__*/_jsx(UITooltip, {
      placement: "left",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: disallowedUserTooltip
      }),
      children: checkbox
    });
  }
  return checkbox;
};
class SelectableUsersList extends Component {
  constructor(...args) {
    super(...args);
    this.renderUserCheckbox = user => {
      const {
        onAddUser,
        onRemoveUser,
        selectedUserIds = [],
        disabledUsers = [],
        disallowedUserTooltip,
        userIdsForSelectedTeamIds = []
      } = this.props;
      const {
        id
      } = user;
      const isMemberOfSelectedTeam = userIdsForSelectedTeamIds.includes(id);
      const isDisabled = disabledUsers.includes(user.id);
      const checked = selectedUserIds.includes(id) || isMemberOfSelectedTeam;
      const displayName = formatUserFullNameForDisplay(user);
      return /*#__PURE__*/_jsx(UserCheckbox, {
        id: id,
        displayName: displayName,
        isMemberOfSelectedTeam: isMemberOfSelectedTeam,
        checked: checked,
        disabled: isDisabled,
        onAddUser: onAddUser,
        onRemoveUser: onRemoveUser,
        disallowedUserTooltip: disallowedUserTooltip
      }, `${id}-user-checkbox`);
    };
  }
  render() {
    const {
      users
    } = this.props;
    const sortedUsers = getSortedUsers(users);
    return /*#__PURE__*/_jsx(UIList, {
      children: sortedUsers.map(this.renderUserCheckbox)
    });
  }
}
SelectableUsersList.propTypes = {
  users: PropTypes.arrayOf(UserOptionType).isRequired,
  userIdsForSelectedTeamIds: PropTypes.arrayOf(PropTypes.number),
  selectedUserIds: PropTypes.arrayOf(PropTypes.number),
  onAddUser: PropTypes.func.isRequired,
  onRemoveUser: PropTypes.func.isRequired,
  disabledUsers: PropTypes.arrayOf(PropTypes.number),
  disallowedUserTooltip: PropTypes.string
};
export default SelectableUsersList;